/* [Component: storesImport] */
import { QuizStore } from '../components/App/stores/QuizStore';
import { HeaderStore } from '../components/Header/stores/HeaderStore';
import { QuestionStore } from '../components/Question/stores/QuestionStore';
import { QuestionWizardStore } from '../components/QuestionWizard/stores/QuestionWizardStore';
import { ResultsStore } from '../components/Results/stores/ResultsStore';
import { TStoreContext } from '../models/app/TStoreContext';
// import { ExampleStore } from '../components/Exmaple/stores/ExampleStore';

export function setupStoreContext(storeContext: TStoreContext) {
	storeContext.set('quizStore', new QuizStore(storeContext, storeContext.manifest));
	storeContext.set('headerStore', new HeaderStore(storeContext, storeContext.manifest));
	storeContext.set('questionStore', new QuestionStore(storeContext, storeContext.manifest));
	storeContext.set('questionWizardStore', new QuestionWizardStore(storeContext, storeContext.manifest));
	storeContext.set('resultsStore', new ResultsStore(storeContext, storeContext.manifest));
	/* [Component: stores] */
}
